export const transformPhotothumbnailDto = photoThumbnailDto => ({
  type: photoThumbnailDto.type,
  url: photoThumbnailDto.url,
  width: photoThumbnailDto.width,
  height: photoThumbnailDto.height,
  isOriginalSize: photoThumbnailDto.original_size
});
export const transformPhotoThumbnailDtos = photoThumbnailDtos => photoThumbnailDtos.map(transformPhotothumbnailDto);
export const transformReactionDto = reactionDto => ({
  id: reactionDto.id,
  type: reactionDto.type
});
export const transformPhotoDto = photoDto => ({
  id: photoDto.id,
  width: photoDto.width,
  height: photoDto.height,
  url: photoDto.url,
  tempUuid: photoDto.temp_uuid,
  dominantColor: photoDto.dominant_color,
  dominantColorOpaque: photoDto.dominant_color_opaque,
  isSuspicious: photoDto.is_suspicious,
  fullSizeUrl: photoDto.full_size_url,
  orientation: photoDto.orientation ? photoDto.orientation : 0,
  thumbnails: transformPhotoThumbnailDtos(photoDto.thumbnails),
  isHidden: photoDto.is_hidden,
  reaction: photoDto.reaction ? transformReactionDto(photoDto.reaction) : undefined
});
export const transformPhotoDtos = photoDtos => photoDtos.map(transformPhotoDto);